// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: 'origin-organizer.firebaseapp.com',
  projectId: 'origin-organizer',
  storageBucket: 'origin-organizer.firebasestorage.app',
  messagingSenderId: '54163027071',
  appId: '1:54163027071:web:1c2e729a5e4d269a75bb4a'
}

// Initialize Firebase
const baseApp = initializeApp(firebaseConfig)
const auth = getAuth(baseApp)
const db = getFirestore(baseApp)
const storage = getStorage(baseApp)

// Set auth persistence to LOCAL (persists across browser sessions)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error setting auth persistence:', error)
})

// Debug Firebase configuration
console.log('Firebase initialized with config:', {
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  hasApiKey: !!firebaseConfig.apiKey
})

export { auth, db, storage }
